module.exports = __webpack_public_path__ + "static/media/level4_flag.44074bb4.svg";